import { render, staticRenderFns } from "./AdminUserForm.vue?vue&type=template&id=b2e56fa4&scoped=true"
import script from "./AdminUserForm.vue?vue&type=script&lang=js"
export * from "./AdminUserForm.vue?vue&type=script&lang=js"
import style0 from "./AdminUserForm.vue?vue&type=style&index=0&id=b2e56fa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e56fa4",
  null
  
)

export default component.exports